import EcoPalmProducts from "./EcoPalmProducts.jsx";
export default EcoPalmProducts